import React, { useState } from 'react';
import { Redirect } from 'react-router-dom';

import { Button } from '@material-ui/core';
import { useNavButtonStyles } from './ConsentDocumentBody';

export const VaccineHistory = () => {

    const navButtonClasses = useNavButtonStyles();
    const [toVaccineHistory, setToVaccineHistory] = useState(false);

    const handleClick = () => {
        setToVaccineHistory(true);
    }

    if (toVaccineHistory) {
        return <Redirect to="/vaccine_history" />;
    }

    return (
        <Button
            color="primary"
            fullWidth={false}
            className={`${navButtonClasses.navButton} ${navButtonClasses.navButtonPrimary}`}
            onClick={handleClick}>
            Vaccinationshistorik
        </Button>
    );
}
